module.exports = __webpack_public_path__ + "assets/img/qsxyj_4.11b3b99c.jpg";